import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormCheckbox } from '@uncinc/uncinc-react-kitchen-sink';

import Button from '../../../Button';

import type { SearchOcularDBHit } from '../../types';

const SearchAllContentOcularResultsOcularHit: React.FC<{ hit: SearchOcularDBHit }> = ({ hit }) => {
  const { t } = useTranslation();

  const imageWidth = Number(hit.ocular_image_width[0]);
  const imageHeight = Number(hit.ocular_image_height[0]);

  // We create a Masonry Grid by creating thin rows 10px high
  // and setting a class to decide how many rows this image must span.

  // Since the image gets rendered at different sizes depending on the viewport
  // we first need to calculate the expected size, so we can set the right grid-rows
  // for each viewport.

  const gridRows: number[] = [];

  // The widths (md, lg, xl) of the left and right column are fixed thanks to bootstrap
  // Md is 12 bootstrap columns,
  // on Lg and Xl we display the entities on 8 bootstrap columns.
  const columnWidthMd = 325;
  const columnWidthLg = 285;
  const columnWidthXl = 365;
  [columnWidthMd, columnWidthLg, columnWidthXl].forEach((columnWidth) => {
    const scaleFactor = columnWidth / imageWidth;
    const renderedImageHeight = imageHeight * scaleFactor;
    gridRows.push(Math.floor(renderedImageHeight / 10));
  });

  return (
    <a
      className={`SearchOcularDB__Results__Hit GridRowEndMd${gridRows[0]} GridRowEndLg${gridRows[1]} GridRowEndXl${gridRows[2]}`}
      href={hit.url[0]}
    >
      <div className="SearchOcularDB__Results__Hit__wrapper">
        <img
          className="SearchOcularDB__Results__Hit__image"
          src={hit.ocular_image[0]}
          alt={hit.title[0]}
        />
        <FormCheckbox
          wrapperClassName="SearchAllContent__Results__checkbox"
          fieldName={`${hit.nid[0]}`}
        />
        <Button
          type="primary"
          className="SearchOcularDB__Results__Hit__button"
        >
          {t('components.search_oculardb.result.view')}
        </Button>
      </div>
      <div className="SearchOcularDB__Results__Hit__title asH5">{hit.diagnosis[0]}{hit.country && `, ${hit.country[0]}`}</div>
    </a>
  );
};

export default SearchAllContentOcularResultsOcularHit;
